module.exports = __webpack_public_path__ + "static/media/drawer4-forest.082e6922.png";